export default __webpack_public_path__ + "static/media/company.4ba7c31a.png";